"use strict";

import React, {Component} from "react";
import PropTypes from "prop-types";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class Callout extends Component {

    static defaultProps = {

    };

    static propTypes = {
        level: PropTypes.string.isRequired,
        icon: PropTypes.string ,
        header: PropTypes.string,
        content: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.node),
            PropTypes.node
        ]),
    };

    constructor(props) {
        super(props);
    }

    render() {
        const { level, icon, header, content } = this.props;
        return (
            <div className={`callout callout-${level}`}>
                <h4>{icon ? <FontAwesomeIcon icon={icon} /> : null} {header}</h4>
                {content}
            </div>
        );
    }
}

export default Callout;